
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.47 16.472L10.667 27.08v11.449c0 .617.498 1.117 1.111 1.117l7.782-.02a1.114 1.114 0 001.105-1.118v-6.686c0-.617.497-1.117 1.111-1.117h4.444c.614 0 1.111.5 1.111 1.117v6.681a1.111 1.111 0 001.111 1.122l7.779.021c.613 0 1.11-.5 1.11-1.117V27.072l-12.799-10.6a.843.843 0 00-1.062 0zm20.222 7.21l-5.805-4.814V9.192a.836.836 0 00-.833-.838h-3.889a.836.836 0 00-.833.838v5.072L26.115 9.12a3.318 3.318 0 00-4.235 0L4.302 23.682a.84.84 0 00-.11 1.18l1.77 2.166a.832.832 0 001.174.114L23.47 13.608a.843.843 0 011.062 0l16.334 13.534a.83.83 0 001.174-.112l1.77-2.166a.842.842 0 00-.118-1.182z","fill":"#535353"}})])
          )
        }
      }
    